import { LoadingStateEnum, Resource } from 'model/Resource';
import { createSelector, Selector } from 'reselect';

export function createResourceContentSelector<S, C>(
  resourceSelector: Selector<S, Resource<C>>,
  notSetContent?: C,
): Selector<S, C> {
  return createSelector(resourceSelector, (resource) =>
    resource && resource.loadingState === LoadingStateEnum.RESOLVED
      ? resource.data
      : (notSetContent as C),
  );
}
